/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2020-12-09 17:00:32
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-20 09:47:49
 * @FilePath: /unifyxp-v2-store-portal/src/tools/getUserInfo.ts
 */
import { get } from 'lodash';
import {
  //EnumResources,
  EnumRole,
  EPermissionSource,
  EResourcesAdmin,
  EResourcesPrefix,
  IQuerySalesChannelResourceParams,
  IQueryStoreResourceParams,
} from 'src/types/common/resources';
import {
  ACCOUNT_INFO as _ACCOUNT_INFO,
  EXP as _EXP,
  ROUTER as _ROUTER,
  SIDER as _SIDER,
  USER_INFO_IN_STORAGE as _USER_INFO_IN_STORAGE,
  USER_LANGUAGE as _USER_LANGUAGE,
  SEVER_URL as _SEVER_URL,
} from './constant';
import moment from 'moment';

const ACCOUNT_INFO = generateKey(_ACCOUNT_INFO);
const EXP = generateKey(_EXP);
const ROUTER = generateKey(_ROUTER);
const SIDER = generateKey(_SIDER);
const USER_INFO_IN_STORAGE = generateKey(_USER_INFO_IN_STORAGE);
const USER_LANGUAGE = generateKey(_USER_LANGUAGE);
const SEVER_URL = generateKey(_SEVER_URL);

const _userLocalInfo = [ACCOUNT_INFO, ROUTER, SIDER, EXP, USER_LANGUAGE];

function getKeyPrefix() {
  const h = get(window, 'location.host');
  return h;
}

function generateKey(k: string) {
  const h = getKeyPrefix();
  return `${h}__unifyXP__${k}`;
}

const getStoreResources = () => {
  const info = getUserInfo();
  return get(info, 'storeResources');
};

const getSalesChannelResources = () => {
  const info = getUserInfo();
  return get(info, 'salesChannelResources');
};

const storeResourceNameGenerator = ({
  category,
  subCategory,
  operation,
  isSelf,
}: IQueryStoreResourceParams) => {
  const _operation = isSelf
    ? `${operation}_${EResourcesPrefix.OWNER_SUFFIX}`
    : operation;
  return `${category}.${subCategory}.${_operation}`;
};

const salesChannelResourceNameGenerator = ({
  category,
  subCategory,
  operation,
  isSelf,
  uuid,
}: IQuerySalesChannelResourceParams) => {
  const _operation = isSelf
    ? `${operation}_${EResourcesPrefix.OWNER_SUFFIX}`
    : operation;

  return `${uuid}.${category}.${subCategory}.${_operation}`;
};

const getStoreResourcePermission = ({
  //对象进来
  category,
  subCategory,
  operation,
  isSelf,
}: IQueryStoreResourceParams): boolean => {
  const rs = getStoreResources();
  return get(
    rs,
    storeResourceNameGenerator({ category, subCategory, operation, isSelf }),
  );
};

const getStoreResourcePermission1 = (name: string | string[]): boolean => {
  //地址进来
  const rs = getStoreResources();
  return get(rs, name);
};

const getSalesChannelResourcePermission = ({
  category,
  subCategory,
  operation,
  isSelf,
  uuid,
}: IQuerySalesChannelResourceParams): boolean => {
  const rs = getSalesChannelResources();
  return get(
    rs,
    salesChannelResourceNameGenerator({
      uuid,
      category,
      subCategory,
      operation,
      isSelf,
    }),
  );
};

const getSalesChannelResourcePermission1 = (
  name: string | string[],
): boolean => {
  const rs = getSalesChannelResources();

  return get(rs, name);
};

const getStoreResourcesPermission = (
  requiredPermissions: IQueryStoreResourceParams[],
): boolean => {
  let isValid = true;

  for (let i = 0; i < requiredPermissions.length; i++) {
    isValid = getStoreResourcePermission(requiredPermissions[i]);
    if (!isValid) {
      break;
    }
  }
  return isValid;
};

const getStoreResourcesPermission1 = (
  requiredPermissions: string[] | string[][],
) => {
  let isValid = true;
  for (let i = 0; i < requiredPermissions.length; i++) {
    isValid = getStoreResourcePermission1(requiredPermissions[i]);
    if (!isValid) {
      break;
    }
  }
  return isValid;
};

const getStoreResourcesPermissionOr1 = (
  requiredPermissions: string[] | string[][],
) => {
  let isValid = false;

  for (let i = 0; i < requiredPermissions.length; i++) {
    isValid = getStoreResourcePermission1(requiredPermissions[i]);
    if (isValid) {
      break;
    }
  }
  return isValid;
};

const getSalesChannelResourcesPermission = (
  requiredPermissions: IQuerySalesChannelResourceParams[],
) => {
  let isValid = true;
  for (let i = 0; i < requiredPermissions.length; i++) {
    isValid = getSalesChannelResourcePermission(requiredPermissions[i]);
    if (!isValid) {
      break;
    }
  }
  return isValid;
};

const getSalesChannelResourcesPermission1 = (
  requiredPermissions: string[] | string[][],
) => {
  let isValid = true;
  for (let i = 0; i < requiredPermissions.length; i++) {
    isValid = getSalesChannelResourcePermission1(requiredPermissions[i]);

    if (!isValid) {
      break;
    }
  }
  return isValid;
};

const getSalesChannelResourcesPermissionOr1 = (
  requiredPermissions: string[] | string[][],
) => {
  let isValid = false;
  //console.log('requiredPermissions', requiredPermissions);
  for (let i = 0; i < requiredPermissions.length; i++) {
    isValid = getSalesChannelResourcePermission1(requiredPermissions[i]);
    if (isValid) {
      break;
    }
  }
  return isValid;
};

function generateSalesChannelResources({
  resources,
}: {
  resources: {
    privileges: {
      category: string;
      subCategory: string;
      operation: string;
      mode: 'Write' | 'Owner';
    }[];
    salesChannelUuid: string;
  }[];
}) {
  const _resources = {};
  resources.forEach((i) => {
    const { privileges, salesChannelUuid } = i;

    const r = generateStoreResources({ resources: privileges || [] });

    _resources[salesChannelUuid] = r;
  });

  return _resources;
}

function generateStoreResources({
  resources,
  prefix,
}: {
  resources: {
    category: string;
    subCategory: string;
    operation: string;
    mode: 'Write' | 'Owner';
  }[];
  prefix?: string;
}) {
  const _resources = {};

  for (let i = 0; i < resources.length; i++) {
    const { category, subCategory, operation, mode } = resources[i];
    if (prefix) {
      if (!_resources[prefix]) {
        _resources[prefix] = {};
      }
      if (!_resources[prefix][category]) {
        _resources[prefix][category] = {};
      }
      if (!_resources[category][subCategory]) {
        _resources[prefix][category][subCategory] = {};
      }
    } else {
      if (!_resources[category]) {
        _resources[category] = {};
      }
      if (!_resources[category][subCategory]) {
        _resources[category][subCategory] = {};
      }
    }

    if (mode == 'Owner') {
      if (prefix) {
        const key1 = `${operation}`;
        const key2 = `${operation}_${EResourcesPrefix.OWNER_SUFFIX}`;
        _resources[prefix][category][subCategory][key1] = true;
        _resources[prefix][category][subCategory][key2] = true;
      } else {
        const key1 = `${operation}`;
        const key2 = `${operation}_${EResourcesPrefix.OWNER_SUFFIX}`;
        _resources[category][subCategory][key1] = true;
        _resources[category][subCategory][key2] = true;
      }
    } else {
      if (prefix) {
        const key = `${operation}`;
        _resources[prefix][category][subCategory][key] = true;
      } else {
        const key = `${operation}`;
        _resources[category][subCategory][key] = true;
      }
    }
  }
  return _resources;
}

function compile(code: string): string {
  // let c = String.fromCharCode(code.charCodeAt(0) + code.length);
  // for (let i = 1; i < code.length; i++) {
  //   c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1));
  // }
  return code;
}

/**
 * 字符串解谜
 * 对应上面的字符串加密方法
 * @param code - 待处理的字符串
 */
function uncompile(code: string): string {
  // let c = String.fromCharCode(code.charCodeAt(0) - code.length);
  // for (let i = 1; i < code.length; i++) {
  //   c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1));
  // }
  return code;
}

const setLocalItem = (key: string, value: string): void => {
  localStorage.setItem(key, value);
};

// export const userLogin = ({ info, expire, payload }: any) => {
//   const _info = JSON.parse(info);
//   _info.token = payload;
//   const _expire = expire.toString();
//   setLocalItem(EXP, compile(_expire));
//   setLocalItem(USER_INFO_IN_STORAGE, compile(JSON.stringify(_info)));
// };

const getLocalItem = ({
  key,
  needUncompile,
}: {
  key: string;
  needUncompile: boolean;
}) => {
  const _item: string = localStorage.getItem(key) || '';
  const item = needUncompile ? uncompile(_item) : _item;
  let re = null;
  try {
    re = JSON.parse(item);
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return re;
};

const removeLocalItem = (key: string) => {
  try {
    window.localStorage.removeItem(key);
  } catch (e) {
    console.warn(e);
  }
};

export const userLogout = () => {
  _userLocalInfo.forEach((i: string) => {
    removeLocalItem(i);
  });
};

export const getServerUrl = () => {
  return getLocalItem({ key: SEVER_URL, needUncompile: true });
};

export const getUserInfo = () => {
  return getLocalItem({ key: ACCOUNT_INFO, needUncompile: true }) || {};
};

export const getTimeStamp = () => {
  return getLocalItem({ key: EXP, needUncompile: true });
};

export const updateTimeStamp = () => {
  //const current = Math.round(new Date().getTime() / 1000);
  const now = new Date();
  const threeHoursLater = now.setHours(now.getHours()).toString();
  setLocalItem(EXP, compile(threeHoursLater));
  //return getLocalItem({ key: EXP, needUncompile: true });
};

export const setLanguage = (language: any) => {
  localStorage.setItem(USER_LANGUAGE, language);
};

export const getLanguage = () => {
  return localStorage.getItem(USER_LANGUAGE);
};

export const checkIsLoginExpire = () => {
  const timeStamp = getTimeStamp();

  if (!timeStamp) return false;
  const current = moment();

  const validPeriodTo = moment(timeStamp).add(3, 'hours');
  const isBetween = current.isSameOrBefore(validPeriodTo); //3小时
  return !isBetween;
};

export const checkIsLogin = () => {
  const token = getUserToken();
  const isExpired = checkIsLoginExpire();

  return token && !isExpired;
};

export const getUserToken = () => {
  const info = getUserInfo();

  if (info) {
    return info.token;
  } else {
    return null;
  }
};

export const getUserName = () => {
  const info = getUserInfo();

  if (info) {
    return info.userName;
  } else {
    return null;
  }
};

export const getStoreName = () => {
  const info = getUserInfo();

  if (info) {
    return info.storeName;
  } else {
    return null;
  }
};

export const getStoreUuid = () => {
  const info = getUserInfo();

  if (info) {
    return info.storeUuid;
  } else {
    return null;
  }
};

export const getLoginDomain = () => {
  const info = getUserInfo();

  if (info) {
    return info.domain; //'http://localhost:3000'; //
  } else {
    return null;
  }
};

export const getUserRole = () => {
  const info = getUserInfo();
  return info.role;
};

// export const checkHasPermission = (
//   //改
//   resources: string[] = [], //拥有的权限
//   requiredResources: string[] = [], //需要的权限
// ) => {
//   const devAllUserAccessible = (requiredResources || []).includes(
//     EnumResources.All,
//   );
//   const isValid =
//     devAllUserAccessible ||
//     intersection(resources, requiredResources).length ===
//       requiredResources.length;
//   return isValid;
// };

const checkHasPermission_role = (
  currentRole: string,
  requiredRoles: string[],
) => {
  const isValid =
    (requiredRoles || []).includes(currentRole) ||
    (requiredRoles || []).includes(EnumRole.All);
  return isValid;
};

const checkIsSuperAdmin = () => {
  const info = getUserInfo();
  return get(info, EResourcesAdmin.superAdmin);
};

// const checkIsTest = () => {
//   const info = getUserInfo();
//   return get(info, EResourcesAdmin.test);
// };

const isUserValid = (
  //role+permission
  {
    resourcesGroup,
    roleGroup,
    source,
  }: {
    resourcesGroup?: string[] | string[][];
    roleGroup?: string[];
    source?: EPermissionSource;
  },
): boolean => {
  // const isTest = checkIsTest();
  // if (isTest) {
  //   return true;
  // }
  //   return true;
  const isLogin = checkIsLogin();

  if (!isLogin) {
    return false;
  }
  const isSuper = checkIsSuperAdmin();

  if (isSuper && isLogin) {
    return true;
  }

  const role = getUserRole();
  const isResValid = () => {
    if (!resourcesGroup) {
      return true; //没有设置resourcesGroup，没有资源限制
    } else {
      if (source === EPermissionSource.store) {
        return getStoreResourcesPermission1(resourcesGroup);
      } else {
        return getSalesChannelResourcesPermission1(resourcesGroup);
      }
    }
    //resourcesGroup ? checkHasPermission(permissions, resourcesGroup) : false;
  };
  const isRoleValid = roleGroup
    ? checkHasPermission_role(role, roleGroup)
    : false;
  return isLogin ? isResValid() || isRoleValid : false;
};

const isUserValidOr = (
  //role+permission
  {
    resourcesGroup,
    roleGroup,
    source,
  }: {
    resourcesGroup?: string[] | string[][];
    roleGroup?: string[];
    source?: EPermissionSource;
  },
): boolean => {
  //   return true;
  const isLogin = checkIsLogin();
  if (!isLogin) {
    return false;
  }

  const isSuper = checkIsSuperAdmin();

  if (isSuper && isLogin) {
    return true;
  }

  const role = getUserRole();
  const isResValid = () => {
    if (!resourcesGroup) {
      return true; //没有设置resourcesGroup，没有资源限制
    } else {
      if (source === EPermissionSource.store) {
        return getStoreResourcesPermissionOr1(resourcesGroup);
      } else {
        return getSalesChannelResourcesPermissionOr1(resourcesGroup);
      }
    }
    //resourcesGroup ? checkHasPermission(permissions, resourcesGroup) : false;
  };

  const isRoleValid = roleGroup
    ? checkHasPermission_role(role, roleGroup)
    : false;
  if (source === EPermissionSource.salesChannel) {
    // console.log('isResValid', isLogin ? isResValid() || isRoleValid : false);
  }
  return isLogin ? isResValid() || isRoleValid : false;
};

export {
  getKeyPrefix,
  isUserValid,
  isUserValidOr,
  ACCOUNT_INFO,
  EXP,
  ROUTER,
  SIDER,
  USER_INFO_IN_STORAGE,
  USER_LANGUAGE,
  generateStoreResources,
  generateKey,
  generateSalesChannelResources,
  checkIsSuperAdmin,
  storeResourceNameGenerator,
  getSalesChannelResources,
  salesChannelResourceNameGenerator,
  getStoreResourcePermission,
  getSalesChannelResourcePermission,
  getStoreResourcesPermission,
  getSalesChannelResourcesPermission,
  getStoreResourcesPermission1,
  getSalesChannelResourcesPermission1,
  getStoreResourcesPermissionOr1,
  getSalesChannelResourcesPermissionOr1,
};
